import React from 'react';
import get from 'lodash/get';

import './LangSummaryTable-style.css';
import { toIntCurrencyString, toFloatCurrencyString } from 'common/stringUtils';

const LangSummaryTable = ({ data }) => {
    const buildLangItems = (langDataRows, totalDiscountAmount) => {
        const items = [];
        const classes = `cell name${totalDiscountAmount <= 0 ? ' large' : ''}`;
        langDataRows &&
            langDataRows.forEach((data, index) => {
                items.push(
                    <li
                        key={`lang-sum-item-${index}`}
                        className="lang-summary-item"
                    >
                        <div className={classes} title={data.name}>
                            {data.name}
                        </div>
                        <div className="cell count">
                            {toIntCurrencyString(data.wordCount)}
                        </div>
                        <div className="cell cost-per-word">
                            {toFloatCurrencyString(get(data, 'costPerWord', 0))}
                        </div>
                        {totalDiscountAmount > 0 && (
                            <div className="cell discount">
                                {data.discount > 0 ? `${data.discount} %` : ''}
                            </div>
                        )}
                        <div className="cell total-cost">
                            {toFloatCurrencyString(get(data, 'totalCost', 0))}
                        </div>
                    </li>
                );
            });

        return items;
    };

    const buildProjectItems = (projects = []) => {
        const projectLen = projects.length;

        return projects.map((project, index) => {
            const classes = `cell name${
                project.totalDiscountAmount <= 0 ? ' large' : ''
            }`;
            return (
                <div
                    key={project.name + index}
                    className="content-container box"
                >
                    <div className="project-info-wrapper">
                        <span className="label">Project:</span>
                        <span>{' ' + project.name}</span>
                    </div>
                    <div className="lang-summary-table">
                        <div className="summary-header">
                            <div className={classes}>Language</div>
                            <div className="cell count">Items</div>
                            <div className="cell cost-per-word">Per word</div>
                            {project.totalDiscountAmount > 0 && (
                                <div className="cell discount">Discount</div>
                            )}
                            <div className="cell total-cost">Cost</div>
                        </div>
                        <ul className="body">
                            {buildLangItems(
                                project.rows,
                                project.totalDiscountAmount
                            )}
                        </ul>
                        {projectLen > 1 && (
                            <div className="summary-footer">
                                <span className="label">Subtotal</span>
                                <span className="value bold-2">
                                    {toFloatCurrencyString(
                                        get(project, 'totalCost', 0)
                                    )}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            );
        });
    };

    return (
        <div className="summary order-summary">
            <div className="title">Order summary</div>
            {buildProjectItems(data)}
        </div>
    );
};

export default LangSummaryTable;
